import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const IntegrationsList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const platforms = [
    {
      "name": "React App",
      "link": "/react-guide"
    },
    {
      "name": "GoDaddy",
      "link": "/godaddy-guide"
    },
    {
      "name": "Hostinger",
      "link": "/hostinger-guide"
    },
    {
      "name": "HTML",
      "link": "/html-guide"
    },
    {
      "name": "Joomla",
      "link": "/joomla-guide"
    },
    {
      "name": "Laravel",
      "link": "/laravel-guide"
    },
    {
      "name": "Shopify",
      "link": "/shopify-guide"
    },
    {
      "name": "Wix",
      "link": "/wix-guide"
    },
    {
      "name": "WordPress",
      "link": "/wordpress-guide"
    },
    {
      "name": "WordPress (Elementor)",
      "link": "/wordpress-elementor-guide"
    }
  ];

  const filteredPlatforms = platforms.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()));

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    if (link.startsWith('/')) {
      navigate(link);
    } else {
      window.open(link, '_blank');
    }
  };

  return (
    <div style={{
      padding: '40px',
      maxWidth: '1000px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#f9f9fb',
      minHeight: '100vh',
      color: '#333'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '36px', color: '#1a1a2e', marginBottom: '15px' }}>Platform Integrations</h1>
        <p style={{ fontSize: '18px', color: '#666', maxWidth: '600px', margin: '0 auto' }}>
          Find detailed tutorials for installing our widget on your favorite website builder or CMS.
        </p>
      </div>

      <div style={{ marginBottom: '30px', display: 'flex', justifyContent: 'center' }}>
        <input 
          type="text" 
          placeholder="Search for your platform..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '12px 20px',
            fontSize: '16px',
            width: '100%',
            maxWidth: '500px',
            borderRadius: '25px',
            border: '1px solid #ccc',
            outline: 'none',
            boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
          }}
        />
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '20px'
      }}>
        {filteredPlatforms.map((platform, idx) => (
          <a 
            key={idx}
            href={platform.link}
            onClick={(e) => handleLinkClick(e, platform.link)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '20px',
              backgroundColor: '#fff',
              borderRadius: '10px',
              textDecoration: 'none',
              color: '#333',
              boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              border: '1px solid #eaeaea'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = '#007BFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              e.currentTarget.style.borderColor = '#eaeaea';
            }}
          >
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{platform.name}</span>
            <span style={{ color: '#007BFF', fontSize: '20px' }}>&rarr;</span>
          </a>
        ))}
        {filteredPlatforms.length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: '#999', fontSize: '18px' }}>
            No platforms found matching "{searchTerm}"
          </div>
        )}
      </div>

      <div style={{ marginTop: '50px', textAlign: 'center', padding: '20px', background: '#fff', borderRadius: '10px', border: '1px solid #eee' }}>
        <h3 style={{ margin: '0 0 10px 0', color: '#444' }}>Don't see your platform?</h3>
        <p style={{ margin: 0, color: '#666' }}>
          Our widget typically works if your platform supports JS and HTML code insertion. Contact us if you encounter any issues during installation!
        </p>
      </div>
    </div>
  );
};

export default IntegrationsList;
